export default {
  // Payment Result Success
  successTitle: 'Payment Successful!',
  successMessage: 'Your payment has been processed successfully.',
  congratulations: 'Congratulations',
  policyIssuedSuccessfully:
    'your Medical Malpractice policy has been issued Successfully.',
  successPaymentBy: 'Success Payment By',
  tamaraPaymentMessage: 'Check your email to enjoy your smart package',
  tabbyPaymentMessage: 'Check your email to enjoy your smart package',
  paymentMethod: 'Payment Method',
  policyNumber: 'Policy Number',
  policyEffectiveDate: 'Policy Effective Date',
  policyExpiryDate: 'Policy Expiry Date',
  policyDuration: 'Policy Duration',
  totalPremium: 'Total Premium',
  includesTaxesAndFees: 'This includes all taxes and fees',
  policyholderDetails: 'Policyholder Details',
  name: 'Name',
  identityNumber: 'Identity Number',
  specialty: 'Specialty',
  placeOfPractice: 'Place of Practice',
  coverage: 'Coverage',
  policyLimit: 'Policy Limit',
  deductible: 'Deductible',
  retroactiveCover: 'Retroactive Cover',
  extendedReportingPeriod: 'Extended Reporting Period',
  features: 'Features',
  benefitsDescription: 'Benefits included in your policy',
  emailNotVerified: 'Your email is not verified',
  verifyEmailMessage:
    'Your email has not been verified yet, please verify to receive the policy documents',
  verifyEmail: 'To verify your email press here',
  printPolicy: 'Print Policy',
  printReceipt: 'Print Receipt',
  backToHome: 'Back to Home',
  startNewRequest: 'Start New Request',
  policyInfo: 'Policy Information',

  // Email Verification
  emailVerificationTitle: 'Email Verification',
  emailVerificationMessage:
    'Please enter the verification code sent to your email',
  verificationCode: 'Verification Code',
  verifyEmailButton: 'Verify Email',
  emailVerifiedSuccess: 'Email was successfully verified',
  enterVerificationCode: 'Enter verification code',

  // Missing translations
  quoteReference: 'Quote Reference',
  dateOfBirth: 'Date of Birth',
  qualification: 'Qualification',
  insuranceCompany: 'Insurance Company',

  // Payment Result Sadad Success
  sadadSuccessTitle: 'SADAD Bill Generated',
  sadadBillDetails: 'Bill Details',
  billerName: 'Biller Name',
  billerCode: 'Biller Code',
  billNumber: 'Bill Number',
  expiryDate: 'Expiry Date',
  invoiceNumber: 'Invoice Number',
  amount: 'Amount',
  currency: 'SAR',
  years: 'Years',
  year: 'Year',
  sadadPaymentMessage:
    'Your SADAD bill has been generated successfully. Please pay it within the specified time.',
  paymentExpiryNote: 'Please pay before this date',

  // Payment Result Failure
  failureTitle: 'Payment Failed',
  failureMessage: 'Please verify your payment method and try again later',
  tryAgain: 'Try Again',
  contactSupport: 'Contact Support',

  // Benefits Section
  benefitsHeaderContent:
    '{{count}} benefits added successfully! More benefits available for longer duration..',
  benefitsSectionDescription:
    'Benefits you will get for {{years}} years policy duration or more.',

  // Common
  loading: 'Loading...',
  error: 'Error',
  somethingWentWrong: 'Something went wrong',

  // New translations
  nameInEnglish: 'Name in English',
  nameInArabic: 'Name in Arabic',

  // New loading-related translations
  waitPendingPayment: 'Please Wait!',
  processingPayment: 'Processing your payment..',
  dontCloseBrowser:
    "Please don't close this window or click on back button on your browser",

  // New translations from the code block
  pleaseWait: 'Please Wait',

  // Policy issuance status messages
  policyIssuanceInProgress: 'Policy issuance in-progress',
  policyIssuanceTimeoutMessage:
    'Policy issuance is in progress, once it is ready, Tameeni will send it by email and you will receive a notification on the registered mobile.',

  // Referral Section
  referAndEarn: 'Refer and Earn',
  referralDescription:
    "You'll earn {{earningPoints}} points for every {{equivalentRiyal}} SAR your referred friend spends on Tameeni Medical Malpractice.",
  shareReferralLink: 'Share Referral Link',

  // Referral Consent Modal
  referralConsentCheckbox: 'I confirm understanding of the conditions',
  referralConsentAccept: 'Accept and Generate Link',
  referralTermsAndConditions:
    'By participating in the referral program, you agree to our terms and conditions. Please read carefully before proceeding.',
  generatingLink: 'Generating Link...',
  shareYourLink: 'Share your link',
  done: 'Done',
  referralLinkGenerated: 'Referral Link Generated!',
  referralLinkMessage:
    'Share this link with your friends and start earning points.',
  copy: 'Copy',
  downloadTermsAndConditions: 'Download Terms & Conditions',
  documentUnavailable: 'Document unavailable',
  checkYourRewards: 'Check your rewards !',
} as const
